module.exports = __webpack_public_path__ + "img/r04.45e83ba3.png";